import axios from "axios";

export default async function fetchScheduledBills(committeeMeetingId) {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_LAWS_BACKEND_HOST}/committees/v1/standingCommitteeMeetingBillHearings/search?limit=100&offset=0`,
      {
        standingCommitteeMeetingIds: [committeeMeetingId]
      }
    );

    if (!Array.isArray(response.data.content) || response.data.length === 0) {
      return [];
    }

    return response.data.content;
  } catch (error) {
    if (error.response?.status !== 404) {
      console.error("Error fetching meeting bill hearings:", error);
    }
    return [];
  }
}
